/* eslint-disable prettier/prettier */
/**
 * Define all application route paths here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import {
  loadView,
  loadViewComponent
} from "./loadView";

export default [
  /** Welcome Paths */
  {
    path: '/',
    name: 'welcome',
    component: loadView('Welcome'),
    children: [
      {
        path: '/',
        name: 'home',
        component: loadViewComponent('welcome', 'home')
      },

    ]
  },
  {
    path: '/welcome/news',
    name: 'news',
    component: loadViewComponent('welcome', 'news')
  },
  {
    path: '/welcome/events',
    name: 'events',
    component: loadViewComponent('welcome', 'events')
  },
  {
    path: '/welcome/news-article/:id',
    name: 'news-article',
    component: loadViewComponent('welcome', 'news-article')
  },
  /** About Paths */
  {
    path: '/about',
    name: 'about',
    component: loadView('About'),
    children: [
      {
        path: '',
        name: 'cor_ucc',
        component: loadViewComponent('about', 'cor_ucc')
      },
      {
        path: 'cor_ucc',
        name: 'cor_ucc',
        component: loadViewComponent('about', 'cor_ucc')
      },
      {
        path: 'cor_staff',
        name: 'cor_staff',
        component: loadViewComponent('about', 'cor_staff')
      },
      {
        path: 'cor_partners',
        name: 'cor_partners',
        component: loadViewComponent('about', 'cor_partners')
      }
    ]
  },
  {
    path: '/about/cor_bishop',
    name: 'cor_bishop',
    component: loadViewComponent('about', 'cor_bishop')
  },
  {
    path: '/visit/site-rental',
    name: 'site-rental',
    component: loadViewComponent('visit', 'site-rental')
  },
  /** Media Paths */
  {
    path: '/media',
    name: 'media',
    component: loadView('Media'),
    children: [
      {
        path: 'live-service',
        name: 'live-service',
        component: loadViewComponent('media', 'live-service')
      },
      {
        path: 'social',
        name: 'social-media',
        component: loadViewComponent('media', 'social')
      }
    ]
  },
  /** Visit Paths */
  {
    path: '/visit',
    name: 'visit',
    component: loadView('Visit'),
    children: [
      {
        path: 'our-church',
        name: 'our-church',
        component: loadViewComponent('visit', 'our-church')
      },
      {
        path: 'contact',
        name: 'contact',
        component: loadViewComponent('visit', 'contact')
      },
      {
        path: 'citizen-action',
        name: 'citizen-action',
        component: loadViewComponent('visit', 'citizen-action')
      }
    ]
  },
  /** Ministries Paths */
  {
    path: '/ministries',
    name: 'ministries',
    component: loadView('Ministries'),
    children: [
      {
        path: 'member-services',
        name: 'member-services',
        component: loadViewComponent('ministries', 'member-services')
      },
      {
        path: 'prayer-circle',
        name: 'prayer-circle',
        component: loadViewComponent('ministries', 'prayer-circle')
      },
      {
        path: 'education',
        name: 'education-ministry',
        component: loadViewComponent('ministries', 'education')
      },
      {
        path: 'mens',
        name: 'mens-ministry',
        component: loadViewComponent('ministries', 'mens')
      },
      {
        path: 'food-pantry',
        name: 'food-pantry',
        component: loadViewComponent('ministries', 'food-pantry')
      },
      {
        path: 'art_music',
        name: 'art_music',
        component: loadViewComponent('ministries', 'art_music')
      },
      {
        path: 'youth',
        name: 'youth-ministry',
        component: loadViewComponent('ministries', 'youth')
      },
    ]
  },
  /** Offerings Paths */
  {
    path: '/offerings',
    name: 'offerings',
    component: loadView('Offerings'),
    children: [
      {
        path: 'tithes',
        name: 'tithes',
        component: loadViewComponent('offerings', 'tithes')
      },
      {
        path: 'amazon-smile',
        name: 'amazon-smile',
        component: loadViewComponent('offerings', 'amazon-smile')
      }
    ]
  },
  { path: '*', redirect: '/' }
]